import "./WrapperStyles.scss";
export const Wrapper = (props: any): any => {
	return <div className="main-wrapper">{props.children}</div>;
};
